(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-ff-footer]:not([data-ff-ready])').forEach(footer => {
      footer.dataset.ffReady = 'true';
      const media = matchMedia('(max-width: 749px)');
      const groups = [...footer.querySelectorAll('[data-ff-links]')];
      const sync = () => groups.forEach(group => { group.open = !media.matches; group.querySelector('summary').tabIndex = media.matches ? 0 : -1; });
      groups.forEach(group => {
        group.querySelector('summary').addEventListener('click', event => { if (!media.matches) event.preventDefault(); });
        group.addEventListener('shopify:block:select', () => { group.open = true; });
      });
      media.addEventListener('change', sync);
      sync();
      const section = footer.closest('.shopify-section');
      if (section) section.addEventListener('shopify:section:unload', () => media.removeEventListener('change', sync), { once: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
